import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

// Labels affiches (francais, cf. CumulDetaillePage.jsx) -> valeurs attendues par
// _scope_filter cote backend (meme convention que SalesMonitoringPage.jsx, qui lui
// affiche directement les labels anglais).
const FILTER_MAP = { Tout: 'All', Groupe: 'Group', Superviseur: 'Supervisor', Banque: 'Bank' };
const PERTE_GAIN_MAP = { Tout: 'All', Perte: 'Loss', Gain: 'Win' };

export const fetchCumulDetaille = ({
  filter, scope, dateFrom, dateTo, lotteryFrom, lotteryUp, perteGain,
}) =>
  apiRequest(`/tickets/cumul-detaille/${toQuery({
    filter: FILTER_MAP[filter] || 'All',
    scope,
    date_from: dateFrom,
    date_to: dateTo,
    tirage_from: lotteryFrom,
    tirage_up: lotteryUp,
    perte_gain: PERTE_GAIN_MAP[perteGain] || 'All',
  })}`);
